import { IApiBaseResponse } from '~/utils/interface/common';
import axiosClient from './axiosClient';

import {
  IForgotPassword,
  ILoginPayload,
  IProfile,
  IResetPassword,
  IUpdateProfile,
  IResponseProfile,
  IUpdateSetting,
} from '~/utils/interface/auth';

const authApi = {
  login(data: ILoginPayload) {
    return axiosClient.post('/api/admin/auth/login', data);
  },
  getProfile() {
    return axiosClient.get<IApiBaseResponse<IProfile>>('/api/admin/auth/profile');
  },
  updateProfile(data: IUpdateProfile) {
    return axiosClient.put<IApiBaseResponse<IResponseProfile>>('/api/admin/auth', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  updateSetting(data: IUpdateSetting) {
    return axiosClient.put<IApiBaseResponse<IResponseProfile>>('/api/admin/auth/settings', data);
  },
  deleteProfile() {
    return axiosClient.delete<IApiBaseResponse<null>>('/api/admin/auth');
  },
  forgotPassword(data: IForgotPassword) {
    return axiosClient.post<IApiBaseResponse<IForgotPassword>>('/api/admin/auth/forgot-password', data);
  },
  resetPassword(data: IResetPassword) {
    return axiosClient.post<IApiBaseResponse<IResetPassword>>('/api/admin/auth/reset-password', data);
  },
  deleteAccount(data: ILoginPayload) {
    return axiosClient.delete('/api/admin/auth/delete-test-account', { data });
  },
};

export default authApi;
